import React from 'react';

import useMetricUsageReport from '../../../../../hooks/useMetricUsageReport';
import ReportUsage from './ReportUsage';
import DashboardGadgetUsage from './DashboardGadgetUsage';
import ScorecardUsage from './ScorecardUsage';
import GoalsUsage from './Goals';
import ChartDefinitionUsage from './ChartDefinitionUsage';
import BoardsUsage from './BoardsUsage';
import CompoundMetricsUsage from './CompoundMetricsUsage';
import PerformanceUsage from './PerformanceUsage';
import BonusProgramUsage from './BonusProgramUsage';
import metricTypeCheckers from '../../../../../types/metricTypeCheckers';

const UsageTab = ({
  metric,
  hideReports = false,
}: {
  metric: Metrics.NormalMetric | Metrics.CompoundMetric;
  hideReports?: boolean;
}) => {
  const usageReport = useMetricUsageReport(metric);

  if (!usageReport) {
    return null;
  }

  const {
    chartDefinitions,
    scorecards,
    goals,
    boards,
    dashboardGadgets,
    compoundMetrics,
    performanceConfigurations,
    reports,
    bonusPrograms,
  } = usageReport;

  return (
    <div>
      {!hideReports && <ReportUsage reports={reports} usedId={metric.id} />}
      <DashboardGadgetUsage
        dashboardGadgets={dashboardGadgets}
        usedId={metric.id}
      />
      <ScorecardUsage scorecards={scorecards} usedId={metric.id} />
      <GoalsUsage goals={goals} usedId={metric.id} />
      <ChartDefinitionUsage
        chartDefinitions={chartDefinitions}
        usedId={metric.id}
      />
      <BoardsUsage boards={boards} usedId={metric.id} />
      {metricTypeCheckers.isNormalMetric(metric) && (
        <CompoundMetricsUsage
          compoundMetrics={compoundMetrics}
          usedId={metric.id}
        />
      )}
      <PerformanceUsage
        performanceConfigs={performanceConfigurations}
        usedId={metric.id}
      />
      <BonusProgramUsage bonusPrograms={bonusPrograms} usedId={metric.id} />
    </div>
  );
};

export default UsageTab;
